


























import { Component,	Vue } from 'vue-property-decorator';

import { bus } from '@/main'
import GlobalMixins from '@/mixins'

@Component
export default class Home extends GlobalMixins {

}
